import React, { useState, useEffect } from "react";
import { Table, Pagination, Spin, Divider, Modal } from "antd";
import axios from "axios";
import { es } from "date-fns/locale/es";
import { useForm } from "react-hook-form";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import lineService from "../../services/line-service";
import palmService from "../../services/palm-service";
import moment from "moment";
import config from "../../config/config";
import sectionService from "../../services/section-service";
import userService from "../../services/user-service";
import pollinationService from "../../services/pollination-service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import DatePicker from "react-datepicker";

const InsertRecord = () => {

  registerLocale("es", es);
  const end_date = moment().endOf("day").toDate();
  const [endDate, setEndDate] = useState(end_date);

  const escoja = [{ _id: 0, name: "-ESCOJA-" }];
  const [listFarms, setListFarms] = useState(escoja);
  const [listLots, setListLots] = useState(escoja);
  const [listLotsDB, setListLotsDB] = useState(escoja);
  const [listLines, setListLines] = useState(escoja);
  const [listPalms, setListPalms] = useState(escoja);
  const [listSection, setListSection] = useState(escoja);
  const [listUsers, setListUsers] = useState(escoja);
  const [listUsersDB, setListUsersDB] = useState(escoja);
  ///Aplicaciones por dia
  const [initReport, setInitReport] = useState(false);


  const [idApplication, setIdApplication] = useState("");
  const [quantity, setQuantity] = useState("");
  const [applicationName, setApplicationName] = useState("");


  const [farmId, setFarmId] = useState("0");
  const [farmName, setFarmName] = useState("");
  const [sectionId, setSectionId] = useState("0");
  const [sectionName, setSectionName] = useState("");
  const [lotId, setLotId] = useState("0");
  const [lotName, setLotName] = useState("");
  const [lotCode, setLotCode] = useState("");
  const [lineId, setLineId] = useState("0");
  const [lineName, setLineName] = useState("");
  const [palmId, setPalmId] = useState("0");
  const [palmName, setPalmName] = useState("");
  const [userId, setUserId] = useState("0");
  const [userName, setUserName] = useState("0");
  const [identification, setIdentification] = useState("0");


  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);



  const [loadingPalm, setLoadingPalm] = useState(false);
  const [loadingLine, setLoadingLine] = useState(false);
  const [loadingUser, setLoadingUser] = useState(false);


  const productList = [
    { id: "0", name: "-Escoja-" },
    { id: "Ana liquido", name: "Ana liquido" },
    { id: "Ana Solido", name: "Ana Solido" },
    { id: "Polen", name: "Polen" }
  ];





  const getListFilterUsers = async () => {


    setLoadingUser(true)
    const userId = "0"
    setListUsers(escoja);
    try {

      let start = moment(endDate).startOf("day").format('YYYY-MM-DD');
      let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
      const response = await userService.listInAccumulation(start, end, farmId, sectionId, lotId)
      const listado = response.data
      if (listado) {
        setListUsersDB(listado)
        const operators = listado.filter(a => a.role == "OPERADOR");
        operators.push({ _id: 0, name: "-ESCOJA-" });
        const sortedItems = operators.sort((a, b) => a.name.localeCompare(b.name));
        setListUsers(sortedItems);
      }
    } catch (error) { }

    setLoadingUser(false)
  }


  const getLisFarm = async () => {
    let listado = await farmService.getList();
    if (listado) {
      listado.push({ _id: 0, name: "-ESCOJA-" });
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListFarms(sortedItems);
    }
  };

  const getListSection = async (e) => {
    setSectionId("0")
    const name = e.target.options[e.target.selectedIndex].text;
    setFarmName(name)
    const code = e.target.value;
    if (code == "0") {
      setListSection(escoja);
      setListLots(escoja);
      setValue("section", "0")
      setValue("lot", "0")
      return;
    }
    let listado = await sectionService.getListByFarm(code);
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListSection(sortedItems);
      setValue("section", "0")
      setValue("lot", "0")
      setValue("line", "0")
    }
  };



  const getListLots = async (e) => {
    setLotId("0")
    const name = e.target.options[e.target.selectedIndex].text;
    setSectionName(name)
    const code = e.target.value;
    if (code == "0") {
      setListLots(escoja);
      setValue("lot", "0")
      setValue("line", "0")
      return;
    }
    let listado = await lotService.getListBySection(code);
    setListLotsDB(listado)
    listado.push({ _id: 0, name: "-ESCOJA-" });
    if (listado) {
      const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
      setListLots(sortedItems);
      setValue("lot", "0")
      setValue("line", "0")
    }
  };

  const getListLines = async (e) => {
    setLineId("0")


    setPalmId("0")
    setListPalms(escoja);
    setValue("palm", "0")


    const name = e.target.options[e.target.selectedIndex].text;
    setLotName(name)
    setLoadingLine(true)
    const code = e.target.value;
    if (code == "0") {
      setListLines(escoja);
      setLoadingLine(false)
      return;
    }


    const item = listLotsDB.find(a => a._id == code)
    setLotCode(item.lotCode)

    let listado = await lineService.getList(code);
    listado.unshift({ _id: 0, name: "-ESCOJA-" });


    if (listado) {
      const sortedList = [...listado].sort((a, b) => {
        const numA = parseInt(a.name);
        const numB = parseInt(b.name);
        return numA - numB;
      });

      setListLines(sortedList);
      setValue("line", "0")
    }

    setLoadingLine(false)

  };



  const getListPalms = async (e) => {
    setPalmId("0")
    setListPalms(escoja);
    setValue("palm", "0")
    const name = e.target.options[e.target.selectedIndex].text;
    setLineName(name)
    setLoadingPalm(true)
    const code = e.target.value;
    if (code == "0") {
      setListLines(escoja);
      setLoadingPalm(false)
      return;
    }
    let listado = await palmService.getListByLine(code);
    listado.unshift({ _id: 0, name: "-ESCOJA-" });


    if (listado) {
      const sortedList = [...listado].sort((a, b) => {
        const numA = parseInt(a.name);
        const numB = parseInt(b.name);
        return numA - numB;
      });

      setListPalms(sortedList);
      setValue("palm", "0")
    }

    setLoadingPalm(false)
  };


  const saveTask = async () => {





    let date = moment(endDate).endOf("day").format('YYYY-MM-DD');
    setLoading(true);
    try {
      const first = getValues("firstApplication") || 0
      const second = getValues("secondApplication") || 0
      const third = getValues("thirdApplication") || 0
      const product = getValues("product")

      const quantity = parseInt(first) + parseInt(second) + parseInt(third)
      if (quantity <= 0) { toast.warning('Ingrese una cantidad!', { autoClose: 1000 }); return; }
      if (farmId == "0") { toast.warning('Seleccione una finca!', { autoClose: 1000 }); return; }
      if (sectionId == "0") { toast.warning('Seleccione una sección!', { autoClose: 1000 }); return; }
      if (lotId == "0") { toast.warning('Seleccione un lote!', { autoClose: 1000 }); return; }
      if (lineId == "0") { toast.warning('Seleccione una línea!', { autoClose: 1000 }); return; }
      if (palmId == "0") { toast.warning('Seleccione una palma!', { autoClose: 1000 }); return; }
      if (userId == "0") { toast.warning('Seleccione un usuario!', { autoClose: 1000 }); return; }
      if (product == "0") { toast.warning('Seleccione un producto!', { autoClose: 1000 }); return; }

      const year = getValues("year")
      const month = getValues("month")
      const week = getValues("week")
      const day = getValues("day")



      const params = {
        date, year, month, week, day,
        farmId,
        farmName,
        sectionId,
        sectionName,
        lotId,
        lotName,
        lotCode,
        lineId,
        lineName,
        palmId,
        palmName,
        userId,
        userName,
        identification,
        first,
        second,
        third,
        product
      }

      const data = await pollinationService.insertManualMovement(params);
      console.log(data.success)
      if (data.success) {
        toast.success(data.message, { autoClose: 1000 })
        setPalmId("0")
        setValue("palm", "0")
        setValue("firstApplication", "0")
        setValue("secondApplication", "0")
        setValue("thirdApplication", "0")
      }
      else {
        toast.error(data.message, { autoClose: 1000 })
      }



    } catch (error) {
      console.error("Error al obtener los movimientos:", error);
    } finally {
      setLoading(false);
    }
  }








  const loadUserData = (value) => {
    if(value=="0") return;
    console.log(value)
    const item = listUsersDB.find(a => a._id == value)
    console.log(item)
    setUserId(item._id)
    setUserName(item.name)
    setIdentification(item.identification)
  }




  const loadDataDay = () => {

    const end_date = moment().endOf("day").toDate();
    const selectedMoment = moment(end_date);
    const dayOfYear = selectedMoment.dayOfYear();
    const month = selectedMoment.month() + 1;
    const year = selectedMoment.year();
    const week = selectedMoment.isoWeek();

    setValue("day", dayOfYear)
    setValue("month", month)
    setValue("year", year)
    setValue("week", week)

    setValue("firstApplication", "0")
    setValue("secondApplication", "0")
    setValue("thirdApplication", "0")

  }

  useEffect(() => {
    getListFilterUsers()
  }, [endDate, farmId, sectionId, lotId]);


  useEffect(() => {
    getLisFarm();
    loadDataDay();
  }, []);

  return (
    <div className="row p-4">
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Ingreso de registro</Divider>
      </div>

      <div className="col-12">
        <form className="form-react">
          <div className="row mb-3">
            <div className="col-12 col-sm-10">
              <div className="row">

                <div className="col-6">

                  <div className="row">


                    <div className="col-6 col-sm-3">
                      <label className="text-secondary fw-bold">Fecha</label>
                      <br />
                      <DatePicker
                        locale="es"
                        dateFormat="yyyy-MM-dd"
                        className="form-control 
                              text-secondary"
                        selected={endDate}
                        onChange={
                          (date) => {
                            setEndDate(date)
                            const selectedMoment = moment(date);
                            const dayOfYear = selectedMoment.dayOfYear();
                            const month = selectedMoment.month() + 1;
                            const year = selectedMoment.year();
                            const week = selectedMoment.isoWeek();
                            setValue("day", dayOfYear)
                            setValue("month", month)
                            setValue("year", year)
                            setValue("week", week)
                          }
                        }
                      />
                    </div>


                    <div className=" col-12 col-sm-9">
                      <label className="text-secondary fw-bold">Finca</label>
                      <select
                        className="form-control text-secondary"
                        {...register("farm")}
                        onChange={(e) => {
                          getListSection(e)
                          const value = e.target.value
                          setFarmId(value)
                        }
                        }
                      >
                        {listFarms.map((option) => (
                          <option key={option._id} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>



                    <div className=" col-12 col-sm-6">
                      <label className="text-secondary fw-bold">Sección</label>
                      <select
                        className="form-control text-secondary"
                        {...register("section")}
                        onChange={(e) => {
                          getListLots(e)
                          const value = e.target.value
                          setSectionId(value)
                        }
                        }
                      >
                        {listSection.map((option) => (
                          <option key={option._id} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>


                    <div className=" col-12 col-sm-6">
                      <label className="text-secondary fw-bold">Lote</label>
                      <select
                        className="form-control text-secondary"
                        {...register("lot")}
                        onChange={
                          (e) => {
                            getListLines(e)
                            const value = e.target.value
                            setLotId(value)
                          }
                        }
                      >
                        {listLots.map((option) => (
                          <option key={option._id} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>






                    <div className=" col-12 col-sm-6">
                      <label className="text-secondary fw-bold">Usuario</label>
                      <Spin spinning={loadingUser}>
                        <select
                          className="form-control text-secondary"
                          {...register("user")}
                          onChange={(e) => {
                            const value = e.target.value;
                            loadUserData(value)
                          }}
                        >
                          {listUsers.map((option) => (
                            <option key={option._id} value={option._id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </Spin>
                    </div>





                    <div className="col-12 col-sm-6">
                      <label>Producto</label>
                      <select className="form-control" {...register("product")}>
                        {productList.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className=" col-12 col-sm-6">
                      <label className="text-secondary fw-bold">Linea</label>

                      <Spin spinning={loadingLine}>
                        <select
                          className="form-control text-secondary"
                          {...register("line")}
                          onChange={
                            (e) => {
                              getListPalms(e)
                              const value = e.target.value
                              setLineId(value)
                            }
                          }
                        >
                          {listLines.map((option) => (
                            <option key={option._id} value={option._id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </Spin>
                    </div>


                    <div className=" col-12 col-sm-6">
                      <label className="text-secondary fw-bold">Palma</label>
                      <Spin spinning={loadingPalm}>
                        <select
                          className="form-control text-secondary"
                          {...register("palm")}
                          onChange={
                            (e) => {
                              const name = e.target.options[e.target.selectedIndex].text;
                              setPalmName(name)
                              const value = e.target.value
                              setPalmId(value)
                            }
                          }
                        >
                          {listPalms.map((option) => (
                            <option key={option._id} value={option._id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </Spin>
                    </div>


                    <div className="col-12 col-sm-3">
                      <label>Año</label>
                      <input
                        type="number"
                        disabled={true}
                        className="form-control"
                        {...register("year")}
                      />
                    </div>



                    <div className="col-12 col-sm-3">
                      <label>Mes</label>
                      <input
                        type="number"
                        disabled={true}
                        className="form-control"
                        {...register("month")}
                      />
                    </div>



                    <div className="col-12 col-sm-3">
                      <label>Semana</label>
                      <input
                        type="number"
                        disabled={true}
                        className="form-control"
                        {...register("week")}
                      />
                    </div>



                    <div className="col-12 col-sm-3">
                      <label>Día</label>
                      <input
                        type="number"
                        disabled={true}
                        className="form-control"
                        {...register("day")}
                      />
                    </div>




                    <div className="col-12 col-sm-3">
                      <label>Primera</label>
                      <input
                        type="number"
                        className="form-control"
                        {...register("firstApplication")}
                      />
                    </div>


                    <div className="col-12 col-sm-3">
                      <label>Segunda</label>
                      <input
                        type="number"
                        className="form-control"
                        {...register("secondApplication")}
                      />
                    </div>


                    <div className="col-12 col-sm-3">
                      <label>Tercera</label>
                      <input
                        type="number"
                        className="form-control"
                        {...register("thirdApplication")}
                      />
                    </div>





                    <div className="col-12 col-sm-3">

                      <div className=" col-12">
                        <label className="text-secondary fw-bold">&nbsp;</label>
                        <br />
                        <Spin spinning={loading}>
                          <button
                            className="btn btn-primary w-100"
                            type="button"
                            onClick={() => saveTask()}
                          >
                            Guardar
                          </button>
                        </Spin>
                      </div>
                    </div>

                  </div>

                </div>





              </div>
            </div>



          </div>
        </form>
      </div>




    </div>
  );
};


export default InsertRecord;
